export function extractApiError(e, fallback) {
  const responseData = e?.response?.data;
  if (responseData?.errors && typeof responseData.errors === 'object') {
    const firstFieldErrors = Object.values(responseData.errors)[0];
    if (Array.isArray(firstFieldErrors) && firstFieldErrors.length > 0) {
      return firstFieldErrors[0];
    }
  }
  return responseData?.message ?? fallback;
}
